import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosNoAuth } from "./axiosInstance";
import { Mixpanel } from "../../config/Mixpanel";


export const fetchOnboardingUserDetails = createAsyncThunk(
    'onboardingUserDetails/fetchOnboardingUserDetails',
    async ({ uuid}) => { 
      
            try {
                const response = await axiosNoAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:jLtpbYQ6/personalised/contact_details', 
                {
                    params: {
                        uuid: uuid
                    }
                });
                return response.data
                
            } catch (err) {
                console.log(err);
            }
  }
);

export const fetchUUID = createAsyncThunk(
    'fetchUUID',
    async ({ name, email, phone_number, skill_name, medium, source }) => {
        try {
            const response = await axiosNoAuth.post('https://ninjacurate.learntube.ai/mobile_app/creation_id', {
                name,
                email,
                phone_number,
                skill_name,
                medium,
                source
            })
            return response.data
        } catch (error) {
            console.log(error.message)
            throw error
        }
    }
)


export const fetchRazorpayId = createAsyncThunk(
    'fetchRazorpayId',
    async ({ uid, amount, product_name }) => {
        try {
            const response = await axiosNoAuth.post("https://xgfy-czuw-092q.m2.xano.io/api:IfQi_Nyx/razorpay_ninjacurate_payment/create_order", {
                uid,
                amount,
                product_name
            })
            return response.data
        } catch (error) {
            console.log(error.message)
            throw error
        }
    }
)

export const fetchUserInitSession = createAsyncThunk(
    'fetchUserInitSession',
    async ({ anon_id, skill_name, role }) => {
        try {
            const response = await axiosNoAuth.post('https://ninjacurate.learntube.ai/personalise/session/init' , {anon_id : "",skill:skill_name, role: role})
            return response.data
        }
        catch (error) {
            console.log(error.message)
            throw error
        }
    }
)



const onboardingUserDetailsSlice = createSlice({
    name: 'onboardingUserDetails',
    initialState : {
        details : {},
        userDetails : {},
        isEvenUser : false,
    },
    reducers: {
       
    },
    extraReducers: (builder) => {
        builder.addCase(fetchOnboardingUserDetails.fulfilled, (state, action) => {
            state.details = action.payload
        })
        builder.addCase(fetchUserInitSession.fulfilled, (state, action) => {
            state.userDetails = action.payload

            // let str = action.payload.session_id;
            // let hash = 0;

            // for (let i = 0; i < str.length; i++) {
            //   hash = ((hash << 5) - hash) + str.charCodeAt(i);
            //   hash |= 0; // Convert to 32bit integer
            // }
          
            // state.isEvenUser = (Math.abs(hash) % 2 === 0);
            state.isEvenUser = false;
            Mixpanel.identify(action.payload.session_id)
            Mixpanel.people.set({is_even : false})
        })
    }

}) 

export const selectOnboardingUserDetails = (state) => state.personaliseLessons?.onboardingUserDetails?.details
export const selectInitSessionUserDetails = (state) => state.personaliseLessons?.onboardingUserDetails?.userDetails
export const selectIsEvenUser = (state) => state.personaliseLessons?.onboardingUserDetails?.isEvenUser
export default onboardingUserDetailsSlice.reducer